//@ts-nocheck
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import {
  motion,
  useMotionTemplate,
  useMotionValue,
  useSpring,
} from "framer-motion";

const BackToVisionButton: React.FC = () => {
  const navigate = useNavigate();
  const ref = useRef(null);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const xSpring = useSpring(x, { mass: 1, stiffness: 300, damping: 30 });
  const ySpring = useSpring(y, { mass: 1, stiffness: 300, damping: 30 });

  const transform = useMotionTemplate`translateX(${xSpring}px) translateY(${ySpring}px)`;

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!ref.current) return;

    const { height, width, left, top } = ref.current.getBoundingClientRect();

    const maxDistance = 5; // Maximum distance the button can move
    const centerX = left + width / 2;
    const centerY = top + height / 2;
    const distanceX = Math.min(maxDistance, Math.abs(e.clientX - centerX));
    const distanceY = Math.min(maxDistance, Math.abs(e.clientY - centerY));

    x.set(e.clientX > centerX ? distanceX : -distanceX);
    y.set(e.clientY > centerY ? distanceY : -distanceY);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  const handleClick = () => {
    navigate('/vision');
  };

  return (
    <motion.button
      ref={ref}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ transform }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      className="group relative grid place-content-center rounded-full border-2 border-black transition-colors duration-700 ease-out bg-white hover:bg-black
                 w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20"
    >
      <FiArrowLeft className="pointer-events-none relative z-10 text-black group-hover:text-white transition-all duration-700 ease-out group-hover:-rotate-45
                              text-xl sm:text-2xl md:text-3xl" />

      <motion.svg
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{
          duration: 25,
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
        }}
        style={{
          top: "50%",
          left: "50%",
          x: "-50%",
          y: "-50%",
        }}
        width="100%"
        height="100%"
        className="pointer-events-none absolute z-10"
      >
        <path
          id="circlePath"
          d="M50,50 m-45,0 a45,45 0 1,0 90,0 a45,45 0 1,0 -90,0"
          fill="none"
        />
        <text className="text-[8px] sm:text-[10px] md:text-xs">
          <textPath
            href="#circlePath"
            className="fill-black group-hover:fill-white font-light uppercase opacity-0 transition-opacity duration-700 ease-out group-hover:opacity-100"
          >
            Back to Vision • Back to Vision •
          </textPath>
        </text>
      </motion.svg>
    </motion.button>
  );
};

export default BackToVisionButton;

